<template>
  <div id="pageRoot">
    <div id="bg">
      <img src="/pages/img/sordoglo/svgGlo30bg.svg" />
      <p class="textBaseCourier" id="text01">ASÍ CANTAN LOS SAPOS</p>
      <p class="textBaseCourier textSimple" id="text02">
        Los sapos "cantan", al igual que los seres humanos, haciendo vibrar las
        cuerdas vocales con el paso del aire.
      </p>

      <p class="textBaseCourier" id="text03">
        ¿CÓMO CONSIGUEN<br>
        UN SONIDO TAN FUERTE?
      </p>
      <p class="textBaseCourier textSimple" id="text04">
        Si pensamos en el tamaño de estos animales, es difícil comprender como
        su canto llega tan lejos. La mayoría de las especies poseen un saco
        vocal. Este saco sirve como caja de resonancia y amplía mucho el volumen
        del sonido.
      </p>
      <p class="textBaseCourier textSimple" id="text05">
        *Texto adaptado para este cuaderno.
      </p>
    </div>
    <img id="zorrito" class="pageElement hover-animation-a" src="/pages/img/sordoglo/svgGlo30Zorrito.svg">
  </div>
</template>
<style scoped>
.textSimple {
  font-size: 22px;
  line-height: 33px;
  color: #000000;
}

#text01 {
  position: absolute;
  width: 440px;
  height: 51px;
  left: 490px;
  top: 100px;
  font-weight: bold;
  font-size: 35px;
  line-height: 40px;
  color: #231f20;
}
#text02 {
  position: absolute;
  width: 429px;
  height: 175px;
  left: 490px;
  top: 152px;
  color: #231f20;
}
#text03 {
  position: absolute;
  width: 455px;
  height: 96px;
  left: 490px;
  top: 300px;
  font-weight: bold;
  font-size: 35px;
  line-height: 45px;
  color: #231f20;
}
#text04 {
  position: absolute;
  width: 440px;
  height: 290px;
  left: 490px;
  top: 400px;
  color: #231f20;
}
#text05 {
  position: absolute;
  width: 480px;
  left: 490px;
  top: 650px;
  color: #231f20;
}
#zorrito{
  position: absolute;
  z-index: 4;
  left: 55px;
  top: 400px;
}
#bg {
  position: absolute;
  left: 31px;
  top: 35px;
  z-index: 3;
  opacity: 0;
  animation-name: enciclopedia-appear;
  animation-duration: 1s;
  animation-delay: 0.3s;
  animation-timing-function: cubic-bezier(0, 0, 0.3, 1.3);
  animation-fill-mode: forwards;
}
@keyframes enciclopedia-appear {
  from {
    opacity: 0;
    top: 500px;
  }
  to {
    opacity: 1;
    top: 35px;
  }
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "glo/Video 139.mp4",
        "glo/Video 140b.mp4",
      ]
    }
  }
}
</script>